/**
 * @generated SignedSource<<8c1a55dfb419e6d6f54156fff7f33a1c>>
 * @relayHash b1b0a620158868bcb3097f7e64a244c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2a1d17515e1fb690dbf5fe3eb1e13c307177dbb996cb2b63f61f4a76aac6006a

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceDetailQuery$variables = {
  includeSpaceTypeSettings: boolean;
  spaceKey?: string | null | undefined;
};
export type useSpaceDetailQuery$data = {
  readonly space: {
    readonly alias: string | null | undefined;
    readonly dataClassificationTags: ReadonlyArray<string | null | undefined>;
    readonly homepage: {
      readonly id: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
    readonly spaceTypeSettings?: {
      readonly enabledContentTypes: {
        readonly isDatabasesEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type useSpaceDetailQuery = {
  response: useSpaceDetailQuery$data;
  variables: useSpaceDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeSpaceTypeSettings"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "dataClassificationTags"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "title"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "condition": "includeSpaceTypeSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
              {
                "concreteType": "EnabledContentTypes",
                "kind": "LinkedField",
                "name": "enabledContentTypes",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isLivePagesEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isWhiteboardsEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isDatabasesEnabled"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpaceDetailQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpaceDetailQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "b1b0a620158868bcb3097f7e64a244c4",
    "id": "2a1d17515e1fb690dbf5fe3eb1e13c307177dbb996cb2b63f61f4a76aac6006a",
    "metadata": {},
    "name": "useSpaceDetailQuery",
    "operationKind": "query",
    "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}}}}"
  }
};
})();

(node as any).hash = "26bee6732f3eb74dc67a3b0c0b99c4b3";

export default node;
